const getters = {
  newItem(state) {
    return state.newItem
  },

  newItemSize(state) {
    let size = Object.keys(state.newItem).length

    return size
  },
}

export { getters }
